import React from "react";

import { Box, Link, Icon, IconButton, Divider, Card, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import LinkIcon from '@mui/icons-material/Link';

// common
import { dic } from "@common/text_defs";
// component

const IssueSection = () => {

  const issueList = [
    {
      name: "課題１：データ収集における非効率",
      text1: `共有機能は存在するが、利用可能なシーンが限られる`,
      text2: `メールでファイルを収集する運用においては、データの集計や進捗管理が難しい`,
    },
    {
      name: `課題２：管理機能が足りない`,
      text1: `同一ファイルのバージョン違いのファイルを多数作成することにより、ファイル管理が煩雑になり、作業者のミスにつながる`,
      text2: `ログ管理機能が限定されているため、問題発生時の原因の特定が困難`,
    },
    {
      name: `課題３：他システムでのデータ再利用が困難`,
      text1: `Excel、CSV、PDFデータは、システムへの直接入力はほぼ不可能`,
      text2: `ERP、CRM、データ・アナリティクス、マシンラーニング、BIツール等を導入する際、データの再利用は困難である`,
    },
    {
      name: `課題４：データの統一化が高コスト`,
      text1: `長年の業務で蓄積したExcelデータ、PDFデータやロジックをシステム化するには相当なコストが発生する`,
      text2: `運用から新システムへ移行した場合、運用も大きく変更となるため、作業員に対する教育が必要となる`,
    },
  ];

  return (
    <Box component="section" className="section bg-light-gray" id="works" sx={{ pb: 0 }}>
      <Box component="div" className="container">
        <Box sx={{ mb: 2, }}>
          <Typography variant="h4" color="primary" sx={{ textAlign: 'center', mx: 'auto', }}>
            解決できる課題
          </Typography>
          <Typography variant="h6" sx={{ textAlign: 'center', mx: 'auto', }}>
            こんなお悩みを抱えていませんか？
          </Typography>
        </Box>
        <Grid container spacing={3}>
          {issueList.map((pane, index) => (
            <Grid md={3} sm={6} xs={12} key={index}>
              <Card className="relative card" key={index} sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
                <Box sx={{ px: 4, pt: 4 }}>
                  <h5 className="m-0 text-16 font-bold">{pane.name}</h5>
                  <p className="mb-4">{pane.text1}</p>
                  <p className="mb-4">{pane.text2}</p>
                </Box>
                <Box sx={{ flexGrow: 1 }}></Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box >
  );
};

export { IssueSection };
